<template>
  <div class="menu-mobile-catalog">
    <div
      class="nav-menu__toggle"
      :class="{ 'nav-menu__toggle_text-center': !bigMenu }"
      @click="onOpenMenu"
    >
      <svg class="menu-mobile__squares"><use xlink:href="#svg-squares"></use></svg>
      <span class="nav-menu__text">{{ messages.catalogTitle }}</span>
    </div>
    <!--        <div-->
    <!--            v-if="isMenuActive"-->
    <!--            v-on:click="onCloseMenu"-->
    <!--            class="nav-menu__overlay" />-->
    <div ref="mobileMenu" class="nav-menu__container" :class="{ isOpened: isMenuActive }">
      <div class="nav-menu__header">
        <div class="nav-menu__back">
          <span @click="onCloseMenu">
            <svg class="menu-mobile__squares"><use xlink:href="#svg-squares"></use></svg>
          </span>
          <div class="title">{{ messages.catalogTitle }}</div>
        </div>

        <svg class="nav-menu__close" @click="onCloseMenu">
          <use data-v-a789cf38="" xlink:href="#svg-close"></use>
        </svg>
      </div>
      <ul class="nav-menu__list nav-menu__scroll">
        <li
          v-for="item in menuObjFiltered"
          :class="{ hasSubMenu: item.items }"
          :style="item.color ? 'color:' + item.color + ';' : ''"
          class="nav-menu__lvl1"
        >
          <a :href="item.href" @click="onOpenSubMenu(item, $event)">{{ item.name }}</a>
          <span v-if="item.items && item.items.length > 0" @click="onOpenSubMenu(item, $event)">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.4858 9L6.46875 15.0171L5.51415 14.0625L10.5767 9L5.51415 3.9375L6.46875 2.9829L12.4858 9Z"
              />
            </svg>
          </span>
        </li>
      </ul>
    </div>

    <div
      v-if="subMenuData"
      ref="mobileSubMenu"
      class="nav-menu__container sub-menu"
      :class="{ isOpened: isSubMenuActive }"
    >
      <div class="nav-menu__header">
        <div class="nav-menu__back" @click="onCloseSubMenu">
          <svg><use xlink:href="#svg-menu-back"></use></svg>
          <div class="title">
            {{ subMenuData.name }}
          </div>
        </div>

        <svg class="nav-menu__close" @click="onCloseSubMenu">
          <use data-v-a789cf38="" xlink:href="#svg-close"></use>
        </svg>
        <!--                <i class="love-closeIcon" v-on:click="onCloseSubMenu" />-->
      </div>
      <div class="nav-menu__scroll">
        <ul v-for="(subItem, i) in subMenuData.items" class="mobile-menu-sub">
          <a
            v-if="i === 0"
            :href="subMenuData.link"
            class="mobile-menu-sub__all"
            :style="subItem.color ? 'color:' + subItem.color + ';' : ''"
          >
            {{ messages.all }} {{ subMenuData.name.toLowerCase() }}
          </a>
          <li
            v-if="subItem.name"
            class="mobile-menu-sub__title"
            :style="!subItem?.items?.length && 'margin-bottom: 0'"
          >
            <a :href="subItem.href" v-html="subItem.name"></a>
          </li>
          <div v-if="subItem?.items?.length" class="mobile-menu-sub-list">
            <li v-for="item in subItem.items" class="mobile-menu-sub-list__item">
              <a v-if="item.href && item.name" :href="item.href" v-html="item.name"></a>
            </li>
          </div>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MenuMobileCatalog',
  props: {
    menuObj: { type: Array },
    bigMenu: {},
    messages: {
      type: Object,
      default() {
        return {
          catalogTitle: 'каталог прикрас (Нужен текст)',
          all: 'Всі',
        };
      },
    },
  },
  data() {
    return {
      isMenuActive: false,
      isSubMenuActive: false,
      subMenuData: [],
      subMenuTitle: '',
    };
  },
  computed: {
    menuObjFiltered() {
      return this.menuObj.slice(0, 10);
    },
  },
  watch: {
    isMenuActive(val) {
      // console.log(val, !this.bigMenu)
      if (!this.bigMenu) {
        if (val) {
          document.body.classList.add('overflow');
        } else {
          document.body.classList.remove('overflow');
        }
      }
    },
  },
  mounted() {
    if (App.debug) {
      console.log('Component: menu-mobile-catalog', this);
    }
  },
  methods: {
    onOpenMenu() {
      this.isMenuActive = true;
      this.$emit('open-menu', this.isMenuActive);
    },
    onCloseMenu() {
      if (this.isSubMenuActive) {
        this.isSubMenuActive = false;
      } else {
        this.isMenuActive = false;
      }
      this.$emit('open-menu', this.isMenuActive);
    },
    onOpenSubMenu({ name, items }, e) {
      if (items && items.length > 0) {
        e.preventDefault();
        this.isSubMenuActive = true;
        this.subMenuData = { name, items };
        this.menuObjFiltered.forEach((el) => {
          if (el.name === name) {
            this.subMenuData = { ...this.subMenuData, link: el.href };
          }
        });
      }
    },
    onCloseSubMenu() {
      this.isSubMenuActive = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-mobile-catalog {
  display: flex;
  align-items: center;
  width: 100%;

  .nav-menu {
    &__toggle {
      display: flex;
      padding: 17px 0;
      width: 100%;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 16px; /* 100% */
      letter-spacing: 1.28px;
      text-transform: uppercase;
      svg {
        width: 16px;
        height: 16px;
        margin-right: 8px;
      }
      &_text-center {
        text-align: center;
        justify-content: center;
      }
    }
    &__text {
      transform: translateY(2px);
    }
    &__close {
      width: 18px;
      height: 18px;
      margin-right: 16px;
      flex-shrink: 0;
    }
    &__container {
      height: 100%;
      width: 100%;
      position: fixed;
      top: 0;
      left: -100%;
      bottom: 0;
      background-color: #fff;
      z-index: 100;
      overflow-y: hidden;
      @include prefix(transition, 0.3s ease-in);

      &.isOpened {
        //right: 0px;
        left: 0;
        @include prefix(animation, fadein 0.7s);
      }

      &.sub-menu {
        z-index: 101;

        li.title {
          color: var(--text-colour-secondary);
          font-weight: 500;
          font-size: rem(16);
          line-height: 100%;
          letter-spacing: 0.1em;
          text-transform: uppercase;
        }
      }
    }
    &__scroll {
      overflow-y: auto;
      max-height: calc(100% - 58px);
      //padding-top: 24px;
    }
    &__list {
      display: grid;
      grid-auto-rows: 50px;
      padding: 0 16px;
      //padding: 16px 24px 0;
      &:first-child {
        //padding: 24px 24px 0;
      }
      > li {
        > a {
          display: inline-block;
          width: 100%;
        }

        &.hasSubMenu {
          vertical-align: middle;
          display: flex;
          align-items: center;
          flex-direction: row;
          justify-content: space-between;
        }
      }
    }

    &__header {
      position: relative;
      min-height: 60px;
      vertical-align: middle;
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: space-between;
      border-bottom: 1px solid #dfdfdf;
      padding-left: 16px;
      .title {
        padding: 0 26px 0 8px;
        font-size: rem(14);
        font-weight: 500;
        transform: translateY(2px);
        letter-spacing: 0.08em;
        text-transform: uppercase;
      }
    }
    &__lvl1 {
      font-weight: 500;
      font-size: rem(16);
      line-height: 100%;
      color: var(--text-colour-primary);

      svg {
        fill: currentColor;
      }
      &:not(:last-child) {
        border-bottom: 1px solid #dfdfdf;
      }
    }
    &__back {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: 600;
      line-height: 16px; /* 100% */
      letter-spacing: 1.28px;
      text-transform: uppercase;
      svg {
        display: block;
        width: 18px;
        height: 18px;
        fill: #191918;
        transform: translateY(-1px);
      }
    }
  }
}
.menu-mobile {
  &__squares {
    transform: translateY(-1px);
    fill: #191918;
    width: 18px;
    height: 18px;
  }
}
.mobile-menu-sub {
  padding: 0 16px;
  &:not(:last-child) {
    .mobile-menu-sub-list {
      border-bottom: 1px solid #dfdfdf;
    }
  }
  &__all {
    display: flex;
    align-items: center;
    height: 46px;
    font-size: 14px;
    font-weight: 600;
    line-height: 100%; /* 14px */
    letter-spacing: 1.4px;
    text-transform: uppercase;
    border-bottom: 1px solid #dfdfdf;
    padding-top: 2px;
  }
  &__title {
    display: flex;
    align-items: center;
    color: #618eaf;
    font-size: 14px;
    font-weight: 600;
    line-height: 100%; /* 14px */
    letter-spacing: 1.4px;
    text-transform: uppercase;
    height: 42px;
    padding-top: 2px;
  }
}
.mobile-menu-sub-list {
  display: grid;
  grid-auto-rows: 42px;
  &__item {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    line-height: 110%;
  }
}
</style>
